import  { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Modal, Badge} from "react-bootstrap";
import { FaSearch, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';

const TOTAL_COLUNAS = 6;

//nomes técnicos das entidades mais auditadas traduzidos para a linguagem da operação
const ENTIDADES = {
    'atendimentos': 'Atendimento',
    'atendimentos_aplicacoes': 'Aplicação',
    'atendimentos_etapas': 'Etapa do atendimento',
    'atendimentos_relatos': 'Relato',
    'atendimentos_servicos': 'Serviço do atendimento',
    'agendamentos': 'Agendamento',
    'beneficiarios': 'Paciente',
    'beneficiarios_medicos': 'Vínculo paciente–médico',
    'prestadores': 'Prestador',
    'prestadores_servicos_procedimentos': 'Serviço do prestador',
    'faturamentos': 'Faturamento',
    'exames': 'Exame',
    'exames_solicitados': 'Exame solicitado',
    'chamados': 'Chamado',
    'chamados_mensagens': 'Mensagem do chamado',
    'programas': 'Programa',
    'programas_prestadores': 'Vínculo prestador–programa',
    'user': 'Usuário',
    'group': 'Grupo',
};

const nomeEntidade = (model) => {
    if(!model){
        return '';
    }

    if(ENTIDADES[model]){
        return ENTIDADES[model];
    }

    const legivel = model.replace(/_/g, ' ');

    return legivel.charAt(0).toUpperCase() + legivel.slice(1);
};

//change_message chega como JSON do Django; traduz para frases legíveis
const formataDetalhes = (mensagem) => {
    if(!mensagem){
        return [];
    }

    let dados;

    try {
        dados = JSON.parse(mensagem);
    }
    catch {
        return [mensagem];
    }

    if(!Array.isArray(dados)){
        return [mensagem];
    }

    return dados.map((item) => {
        if(item.added){
            return item.added.name
                ? `Incluído: ${item.added.name} "${item.added.object}"`
                : 'Registro incluído.';
        }

        if(item.deleted){
            return item.deleted.name
                ? `Removido: ${item.deleted.name} "${item.deleted.object}"`
                : 'Registro removido.';
        }

        if(item.changed){
            const campos = (item.changed.fields || []).join(', ');

            if(item.changed.name){
                return `Alterado em ${item.changed.name} "${item.changed.object}": ${campos}`;
            }

            return campos ? `Campos alterados: ${campos}` : 'Registro alterado.';
        }

        return JSON.stringify(item);
    });
};

const variantAcao = (action_flag_id) => {
    if(action_flag_id === 1){
        return 'success';
    }

    if(action_flag_id === 3){
        return 'danger';
    }

    return 'primary';
};

class Logs extends Component {
    constructor(props) {
        super(props);
        this.onChangeFiltro = this.onChangeFiltro.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaLog = this.buscaLog.bind(this);
        this.limpaFiltros = this.limpaFiltros.bind(this);

        this.state = {
            listResults: [],
            error: "",
            filtro_busca: "",
            filtro_usuario: "",
            filtro_acao: "",
            filtro_area: "",
            filtro_entidade: "",
            filtro_registro_id: "",
            filtro_data_de: "",
            filtro_data_ate: "",
            areas: [],
            acoes: [],
            showModal: false,
            logSelecionado: null,
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaFiltros()
        this.consultaLogs()
    }

    consultaFiltros(){
        api.get('/logs/filtros/')
        .then(response => {
            this.setState({
                areas: response.data.areas || [],
                acoes: response.data.acoes || [],
            });
        })
        .catch(() => {
            //sem as opções os selects ficam vazios, mas a listagem segue utilizável
            this.setState({ areas: [], acoes: [] });
        });
    }

    montaFiltros(){
        let filtros = "";

        if(this.state.filtro_busca){
            filtros += `&busca=${encodeURIComponent(this.state.filtro_busca)}`;
        }

        if(this.state.filtro_usuario){
            filtros += `&usuario=${encodeURIComponent(this.state.filtro_usuario)}`;
        }

        if(this.state.filtro_acao){
            filtros += `&acao=${this.state.filtro_acao}`;
        }

        if(this.state.filtro_area){
            filtros += `&area=${encodeURIComponent(this.state.filtro_area)}`;
        }

        if(this.state.filtro_entidade){
            filtros += `&entidade=${encodeURIComponent(this.state.filtro_entidade)}`;
        }

        if(this.state.filtro_registro_id){
            filtros += `&registro_id=${encodeURIComponent(this.state.filtro_registro_id)}`;
        }

        if(this.state.filtro_data_de){
            filtros += `&data_de=${this.state.filtro_data_de}`;
        }

        if(this.state.filtro_data_ate){
            filtros += `&data_ate=${this.state.filtro_data_ate}`;
        }

        return filtros;
    }

    consultaLogs(page_numb=1){
        api.get(`/logs/?page=${page_numb}${this.montaFiltros()}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listResults: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar logs, tente novamente.';

            //sem resposta quando a requisição sequer chega ao servidor
            if(error.response?.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response?.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    entidadesDaArea(){
        if(!this.state.filtro_area){
            return [];
        }

        const area = this.state.areas.find((a) => a.area === this.state.filtro_area);

        return area ? area.entidades : [];
    }

    openModal(log) {
        this.setState({ showModal: true, logSelecionado: log });
    }

    closeModal() {
        this.setState({ showModal: false, logSelecionado: null });
    }

    renderRows = () => {
        if('results' in this.state.listResults && this.state.listResults.results.length > 0){
            return this.state.listResults.results.map((item) =>
            <tr key={item.id}>
                <td>{formataDataHoraExibicao(item.action_time)}</td>
                <td>
                    <Badge bg={variantAcao(item.action_flag_id)}>{item.action_flag}</Badge>
                </td>
                <td>{item.user__first_name} {item.user__last_name}</td>
                <td>
                    {nomeEntidade(item.content_type__model)}
                    <div className="text-muted small">{item.content_type__app_label}</div>
                </td>
                <td>
                    <Button
                        variant="link"
                        size="sm"
                        className="p-0 m-0 text-start"
                        onClick={() => this.openModal(item)}
                    >
                        {item.object_repr || `#${item.object_id}`}
                    </Button>
                    <div className="text-muted small">ID {item.object_id}</div>
                </td>
                <td>
                    {formataDetalhes(item.change_message).join(' · ') || '—'}
                </td>
            </tr>
            );
        }

        return (
            <tr>
                <td colSpan={TOTAL_COLUNAS}>Nenhum log encontrado para os filtros aplicados</td>
            </tr>
        );
    };

    onChangeFiltro(e) {
        const { name, value } = e.target;
        const novoEstado = { [name]: value };

        if(name === 'filtro_area'){
            novoEstado.filtro_entidade = "";
        }

        this.setState(novoEstado);
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.consultaLogs(num_page)
    }

    buscaLog(e) {
        e.preventDefault();

        this.setState({
            loading: true,
            page_numb: 1,
        });

        this.consultaLogs()
    }

    limpaFiltros() {
        this.setState({
            loading: true,
            filtro_busca: "",
            filtro_usuario: "",
            filtro_acao: "",
            filtro_area: "",
            filtro_entidade: "",
            filtro_registro_id: "",
            filtro_data_de: "",
            filtro_data_ate: "",
            page_numb: 1,
        }, () => {
            this.consultaLogs()
        });
    }

    render() {
        if (!hasPerm('view_logentry')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Logs</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaLog}>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data de</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_de"
                                            value={this.state.filtro_data_de}
                                            onChange={this.onChangeFiltro}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data até</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="filtro_data_ate"
                                            value={this.state.filtro_data_ate}
                                            onChange={this.onChangeFiltro}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuário</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_usuario"
                                            value={this.state.filtro_usuario}
                                            onChange={this.onChangeFiltro}
                                            placeholder="Nome ou sobrenome"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ação</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_acao"
                                            value={this.state.filtro_acao}
                                            onChange={this.onChangeFiltro}
                                        >
                                            <option value="">Todas</option>
                                            {this.state.acoes.map((a) =>
                                                <option key={a.id} value={a.id}>{a.nome}</option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="filtro_area"
                                            value={this.state.filtro_area}
                                            onChange={this.onChangeFiltro}
                                        >
                                            <option value="">Todas</option>
                                            {this.state.areas.map((a) =>
                                                <option key={a.area} value={a.area}>{a.area}</option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                {this.state.filtro_area && (
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Entidade</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="filtro_entidade"
                                                value={this.state.filtro_entidade}
                                                onChange={this.onChangeFiltro}
                                            >
                                                <option value="">Todas</option>
                                                {this.entidadesDaArea().map((m) =>
                                                    <option key={m} value={m}>{nomeEntidade(m)}</option>
                                                )}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                )}

                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Id do registro</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_registro_id"
                                            value={this.state.filtro_registro_id}
                                            onChange={this.onChangeFiltro}
                                            placeholder="Ex.: 5040"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Busca</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_busca"
                                            value={this.state.filtro_busca}
                                            onChange={this.onChangeFiltro}
                                            placeholder="Descrição ou detalhe"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Button type="submit" variant="success" size="sm">
                                <FaSearch className="me-2" /> Filtrar
                            </Button>
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={this.limpaFiltros}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
                <Card className="cardDestaque">
                    <Card.Body className="pt-0">
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Ação</th>
                                    <th>Usuário</th>
                                    <th>Entidade</th>
                                    <th>Registro</th>
                                    <th>Detalhes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={TOTAL_COLUNAS}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={TOTAL_COLUNAS}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>
                        {
                            'results' in this.state.listResults && this.state.listResults.results.length > 0 &&
                            <Paginacao dados={this.state.listResults} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }
                    </Card.Body>
                </Card>

                <Modal
                    show={this.state.showModal}
                    onHide={() => this.closeModal()}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Detalhes do Log</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.logSelecionado && (
                            <>
                                <p className="mb-1">
                                    <strong>Data:</strong> {formataDataHoraExibicao(this.state.logSelecionado.action_time)}
                                </p>
                                <p className="mb-1">
                                    <strong>Usuário:</strong> {this.state.logSelecionado.user__first_name} {this.state.logSelecionado.user__last_name}
                                </p>
                                <p className="mb-1">
                                    <strong>Ação:</strong>{' '}
                                    <Badge bg={variantAcao(this.state.logSelecionado.action_flag_id)}>
                                        {this.state.logSelecionado.action_flag}
                                    </Badge>
                                </p>
                                <p className="mb-1">
                                    <strong>Entidade:</strong> {nomeEntidade(this.state.logSelecionado.content_type__model)} ({this.state.logSelecionado.content_type__app_label})
                                </p>
                                <p className="mb-1">
                                    <strong>Registro:</strong> {this.state.logSelecionado.object_repr} (ID {this.state.logSelecionado.object_id})
                                </p>

                                <hr />

                                {formataDetalhes(this.state.logSelecionado.change_message).length > 0 ? (
                                    <ul className="mb-0">
                                        {formataDetalhes(this.state.logSelecionado.change_message).map((d, i) =>
                                            <li key={i}>{d}</li>
                                        )}
                                    </ul>
                                ) : (
                                    'Nenhuma descrição adicional.'
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.closeModal()}>
                        Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Logs);
